/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { SidebarSelector } from "~/components/SidebarSelector";
import { UniversalWrap } from "~/components/Utils";
import { useResourceTypeOptions } from "~/hooks";

type Props = {
  onSubmit: (value: string) => void;
  onClose: () => void;
  isOpen: boolean;
  excludeItems?: string[];
};

export function ResourceTypeSelector({
  onSubmit,
  onClose,
  isOpen,
  excludeItems,
}: Props) {
  const { options, loading, error } = useResourceTypeOptions(excludeItems);

  return (
    <UniversalWrap
      errorProps={{ error }}
      loaderProps={{
        loading: isOpen && loading,
        inContent: true,
      }}
    >
      <SidebarSelector
        hasIcon
        hasSubtitle
        limit={20}
        isOpen={isOpen}
        options={options}
        name="Resource Type"
        onClick={onClose}
        onSubmit={onSubmit}
      />
    </UniversalWrap>
  );
}
